import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { replyEmail } from '../../../actions/admin/form/contact_form';
import { basicMsg, simpleConfirmDialog } from '../../../actions/swal_msg';

import {
    Button, Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Stack, Typography
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

const FormDialog = ({ setForms, open1, setDialog, selectedForm }) => {
    const {
        _id, fullname, email_content: { subject, msg }, replied
    } = selectedForm;

    const dispatch = useDispatch();

    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = async () => {
        if (message.length >= 5) {
            if (await simpleConfirmDialog('¿Desea salir del formulario?', 'Sí, continuar')) {
                setMessage('');
                setDialog(e => ({ ...e, open2: true, open1: false }));
            }
        } else {
            setMessage('');
            setDialog(e => ({ ...e, open2: true, open1: false }));
        }
    };

    const handleOnChange = ({ target }) => {
        if (target.value.length <= 2000)
            setMessage(target.value);
    };

    const sendEmail = async () => {
        if (replied) {
            basicMsg('Ya ha respondido a este contacto');
            return;
        }
        if (_id && message.length > 4)
            await replyFn();
        else basicMsg('Ingrese una respuesta más extensa');
    };

    const replyFn = async () => {
        setLoading(true);
        const req = await replyEmail({ _id, message }, setLoading, dispatch);
        if (req.status) {
            setForms(e => e.map(
                u => u._id === _id ?
                { ...u, replied: true } : u
            ));
            setDialog(e => ({ ...e, open2: false, open1: false }));
            setMessage('');
        }
    }

    return (
        <Dialog
            fullWidth
            sx={{ zIndex: 1000 }}
            open={ open1 }
            onClose={ handleClose }>
            <DialogTitle>
                { `Asunto: ${subject}` }
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Typography variant="body2" gutterBottom>
                        { `${fullname} escribe...` }
                    </Typography>
                    <Typography variant="button" gutterBottom
                        sx={{ display: 'block' }}>
                        { `"${msg}"` }
                    </Typography>
                    <TextField
                        variant="filled"
                        label="Respuesta:"
                        multiline
                        rows={4}
                        value={ message }
                        onChange={ handleOnChange }
                    />
                    
                </Stack>
            </DialogContent>
            
            <DialogActions>
                <Button onClick={ handleClose }>
                    Regresar
                </Button>
                <LoadingButton
                    autoFocus
                    endIcon={<SendIcon />}
                    loading={ loading }
                    loadingPosition="end"
                    onClick={ sendEmail }>
                    Enviar
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default FormDialog;